import React from 'react';
// import { Dropdown } from 'rsuite';
import Dropdown from 'rsuite/esm/Dropdown';
import { SystemShared } from '../../shared/system';
import { UserDataWeb } from '../../shared/userdataweb';
import { getAllLangs, langData, LangIdName } from '../../src/lang';
import { GetPayPeriodItem, LangBlock, loadAllNews, LogoWhite, ProductIcon } from './global';
import { EventSystem } from './events';
import { observer } from 'mobx-react';
import { WebStorage } from '../storage';
import { PRODUCTS_LIST } from '../../shared/products';
import { NewsItem } from '../../shared/news';

export const RenderNotifyBlock = observer(
    (props: {
        inside: any;
        items: {
            id: string;
            url?: string;
            img?: string;
            title?: string;
            text?: string;
            timestamp?: number;
            langDataTitle?: langData;
            langDataTitleArgs?: any[];
            langDataText?: langData;
            langDataTextArgs?: any[];
        }[];
        hasNew?: boolean;
        onClick?: () => void;
    }) => {
        // console.log(props.items);

        const [lang, setLang, LangString] = LangBlock();

        return (
            <div className="balanceBlock newsBlock">
                <Dropdown
                    placement="bottomEnd"
                    title={
                        <span className="balance">
                            {props.hasNew ? (
                                <>
                                    <span
                                        style={{
                                            marginRight: '5px',
                                            color: 'red',
                                            fontSize: '3rem',
                                        }}
                                    >
                                        •
                                    </span>
                                </>
                            ) : (
                                ``
                            )}
                            {props.inside}
                        </span>
                    }
                    onOpen={() => {
                        if (props.onClick) {
                            props.onClick();
                        }
                    }}
                >
                    {props.items.map((data, i) => {
                        if (!data) {
                            return <></>;
                        }

                        return (
                            <Dropdown.Item
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                                disabled={true}
                            >
                                <div
                                    className={`newsItemBlock ${data.img ? '' : 'noImg'} ${
                                        data.url ? 'link' : ''
                                    }`}
                                    onClick={(e) => {
                                        e.preventDefault();

                                        if (data.url) {
                                            location.replace(data.url);
                                        }
                                    }}
                                >
                                    {data.img ? <img className="imgTitle" src={data.img} /> : <></>}
                                    {data.title ? (
                                        <div
                                            className="title"
                                            dangerouslySetInnerHTML={{
                                                __html: data.title,
                                            }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {data.langDataTitle ? (
                                        <div
                                            className="title"
                                            dangerouslySetInnerHTML={{
                                                __html: data.langDataTitleArgs
                                                    ? LangString(
                                                          data.langDataTitle,
                                                          ...data.langDataTitleArgs,
                                                      )
                                                    : LangString(data.langDataTitle),
                                            }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {data.text ? (
                                        <div
                                            className="text"
                                            dangerouslySetInnerHTML={{
                                                __html: data.text,
                                            }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {data.langDataText ? (
                                        <div
                                            className="text"
                                            dangerouslySetInnerHTML={{
                                                __html: data.langDataTextArgs
                                                    ? LangString(
                                                          data.langDataText,
                                                          ...data.langDataTextArgs,
                                                      )
                                                    : LangString(data.langDataText),
                                            }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {data.timestamp ? (
                                        <div className="timestamp">
                                            {SystemShared.timeStampString(data.timestamp)}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown>
            </div>
        );
    },
);

export const Header = observer(
    (props: {
        addBalanceClick?: () => void;
        openCartClick?: () => void;
        historyBalanceClick?: () => void;
        referralClick?: () => void;
        addText?: string;
    }) => {
        const { userData, page } = WebStorage;
        const [lang, setLang, LangString] = LangBlock();
        const [openCart, setOpenCart] = React.useState(false);

        const [news, setNews] = React.useState<NewsItem[]>([]);
        const [messages, setMessages] = React.useState<NewsItem[]>([]);

        React.useEffect(() => {
            loadAllNews().then((res) => {
                if (res) {
                    setNews(res);
                }
            });
        }, []);

        React.useEffect(() => {
            if (!userData?.id) {
                return setMessages([]);
            }

            const load = () => {
                WebStorage.ApiRequest('/api/getMessages').then((res) => {
                    if (res.status) {
                        setMessages(res.data);
                    }
                });
            };

            load();

            const int = setInterval(() => {
                load();
            }, 30 * 1000);

            return () => {
                clearInterval(int);
            };
        }, [userData?.id]);

        React.useEffect(() => {
            if (!WebStorage.cart.length) {
                setOpenCart(false);
            }
        }, [WebStorage.cart.length]);

        return (
            <>
                {WebStorage.cart.length && openCart ? (
                    <div className="modalBG">
                        <div
                            className="modalBG2"
                            onClick={(e) => {
                                e.preventDefault();
                                setOpenCart(false);
                            }}
                        ></div>
                        <div className="modalMain">
                            <div className="title">
                                {LangString(
                                    'WebOrderControlPayButtonHeader',
                                    WebStorage.cart.length,
                                )}
                            </div>
                            <div className="cartModalBody">
                                {WebStorage.cart.map((item, i) => {
                                    const cfg = PRODUCTS_LIST.find((q) => q.type === item.type);

                                    if (!cfg) {
                                        return <></>;
                                    }

                                    const per = GetPayPeriodItem(item.index, cfg);

                                    if (!per) {
                                        return;
                                    }

                                    return (
                                        <div
                                            className="item"
                                            key={i}
                                            onClick={(e) => {
                                                e.preventDefault();

                                                WebStorage.cart = WebStorage.cart.filter(
                                                    (q) => q.id !== item.id,
                                                );
                                            }}
                                        >
                                            <img src={ProductIcon(item.type)} alt="" />
                                            <div className="text">
                                                <div className="tlt">{LangString(cfg.name)}</div>
                                                <div className="desc">
                                                    {LangString(per[0], per[1], per[2], per[3])}
                                                </div>
                                            </div>
                                            <button className="remove">
                                                <img
                                                    src={require('../images/remove.svg').default}
                                                    alt=""
                                                />
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
                <div className="header">
                    <div
                        className="left"
                        onClick={(e) => {
                            e.preventDefault();

                            const url = `${location.protocol}//${location.host}/`;

                            history.pushState({}, null as any, url);
                        }}
                    >
                        <img alt={'RocketMan'} src={LogoWhite} /> <span>RocketMan</span>
                        {props.addText ? <span className="addText">- {props.addText}</span> : ``}
                    </div>
                    <div className="right">
                        {userData && userData.id && messages.length ? (
                            <>
                                <RenderNotifyBlock
                                    inside={<img src={require('../images/message.svg').default} />}
                                    items={messages}
                                    hasNew={userData?.lastNotify != messages[0].id}
                                    onClick={() => {
                                        if (!userData) {
                                            return;
                                        }

                                        if (userData.lastNotify != messages[0].id) {
                                            WebStorage.ApiRequest(`/api/set/lastNotify`, {
                                                lastNotify: messages[0].id,
                                            }).then((res) => {
                                                console.log(res);

                                                if (res.status) {
                                                    WebStorage.setLastNotify(messages[0].id);
                                                }
                                            });
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                        {news.length ? (
                            <>
                                <RenderNotifyBlock
                                    inside={<img src={require('../images/news.svg').default} />}
                                    items={news.map((q) => {
                                        return {
                                            ...q.data[lang],
                                            timestamp: q.timestamp,
                                            id: q.id,
                                        };
                                    })}
                                    hasNew={
                                        !!userData &&
                                        !!userData.id &&
                                        userData?.lastNews != news[0].id
                                    }
                                    onClick={() => {
                                        if (!userData) {
                                            return;
                                        }

                                        if (userData.lastNews != news[0].id) {
                                            WebStorage.ApiRequest(`/api/set/lastNews`, {
                                                lastNews: news[0].id,
                                            }).then((res) => {
                                                if (res.status) {
                                                    WebStorage.setLastNews(news[0].id);
                                                }
                                            });
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                        {userData && page === 'dashboard' ? (
                            <>
                                <div className="balanceBlock">
                                    <Dropdown
                                        placement="bottomEnd"
                                        title={
                                            <span className="balance">
                                                <img
                                                    src={require('../images/balance.svg').default}
                                                />
                                                <span className="dashboardButtonText">
                                                    $
                                                    {SystemShared.numberFormat(
                                                        userData.balance,
                                                        false,
                                                    )}
                                                </span>
                                            </span>
                                        }
                                    >
                                        <Dropdown.Item
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                            disabled={true}
                                        >
                                            <div className="balanceData">
                                                <div className="info">
                                                    <img
                                                        src={
                                                            require('../images/balance.svg').default
                                                        }
                                                    />
                                                    <div className="infoData">
                                                        <div>
                                                            $
                                                            {SystemShared.numberFormat(
                                                                userData.balance,
                                                                false,
                                                            )}
                                                        </div>
                                                        <span>
                                                            {LangString('CurrentBalanceDesc')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={(e) => {
                                                if (props.addBalanceClick) {
                                                    props.addBalanceClick();
                                                }
                                            }}
                                        >
                                            <span className="badd">
                                                <img src={require('../images/pay.svg').default} />{' '}
                                                {LangString('WebDashboardBalanceAdd')}
                                            </span>
                                        </Dropdown.Item>
                                        {props.historyBalanceClick ? (
                                            <Dropdown.Item
                                                onClick={(e) => {
                                                    if (props.historyBalanceClick) {
                                                        props.historyBalanceClick();
                                                    }
                                                }}
                                            >
                                                <span className="badd">
                                                    <img
                                                        src={
                                                            require('../images/history.svg').default
                                                        }
                                                    />{' '}
                                                    {LangString('WebDashboardBalanceHistory')}
                                                </span>
                                            </Dropdown.Item>
                                        ) : (
                                            <></>
                                        )}
                                        {props.referralClick ? (
                                            <Dropdown.Item
                                                onClick={(e) => {
                                                    if (props.referralClick) {
                                                        props.referralClick();
                                                    }
                                                }}
                                            >
                                                <span className="badd">
                                                    <img
                                                        src={
                                                            require('../images/referral.svg')
                                                                .default
                                                        }
                                                    />{' '}
                                                    {LangString('WebDashboardBalanceReferral')}
                                                </span>
                                            </Dropdown.Item>
                                        ) : (
                                            <></>
                                        )}
                                    </Dropdown>
                                    {WebStorage.cart.length > 0 && (
                                        <Dropdown
                                            noCaret
                                            placement="bottomEnd"
                                            title={
                                                <span className="balance">
                                                    <img
                                                        src={require('../images/cart.svg').default}
                                                    />
                                                    <span className="dashboardButtonText">
                                                        {LangString(
                                                            'WebOrderControlPayButtonHeader',
                                                            WebStorage.cart.length,
                                                        )}
                                                    </span>
                                                </span>
                                            }
                                            onClick={(e) => {
                                                e.preventDefault();

                                                if (props.openCartClick) {
                                                    props.openCartClick();
                                                }
                                            }}
                                        />
                                    )}
                                </div>
                                {/* {WebStorage.cart.length > 0 ? (
                                    <div>
                                        <button
                                            className="rs-dropdown-toggle rs-btn rs-btn-default cart"
                                            id="cartButton"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setOpenCart((old) => !old);
                                            }}
                                        >
                                            <img src={require('../images/cart.svg').default} />
                                            <span>
                                                {LangString(
                                                    'WebOrderControlPayButtonHeader',
                                                    WebStorage.cart.length,
                                                )}
                                            </span>
                                        </button>
                                    </div>
                                ) : (
                                    <></>
                                )} */}
                                <div className="userdata">
                                    <Dropdown
                                        // noCaret
                                        placement="bottomEnd"
                                        title={
                                            <>
                                                {userData.avatar ? (
                                                    <img className="avatar" src={userData.avatar} />
                                                ) : (
                                                    <></>
                                                )}{' '}
                                                <span className="username dashboardButtonText">
                                                    {userData.name}
                                                </span>
                                            </>
                                        }
                                    >
                                        <Dropdown.Item
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                        >
                                            <img src={require('../images/user.svg').default} />
                                            <span className="mfnt"> {LangString('WebHeaderUserId', userData.id)}</span>
                                        </Dropdown.Item>
                                        {userData.admin ? (
                                            <>
                                                <Dropdown.Item
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        EventSystem.setPage('admin');
                                                    }}
                                                >
                                                    <img
                                                        src={require('../images/admin.svg').default}
                                                    />{' '}
                                                    <span className="mfnt">{LangString('AdminPanel')}</span>
                                                </Dropdown.Item>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        <Dropdown.Item
                                            onClick={(e) => {
                                                e.preventDefault();

                                                const url = `${location.protocol}//${location.host}/`;

                                                localStorage.removeItem('userData');
                                                history.pushState({}, null as any, url);

                                                setTimeout(() => {
                                                    WebStorage.setUserData(undefined);
                                                }, 500);
                                            }}
                                        >
                                            <img src={require('../images/exit.svg').default} />{' '}
                                            <span className="mfnt">{LangString('WebHeaderExit')}</span>
                                        </Dropdown.Item>
                                    </Dropdown>

                                    {/* 
                                {userData.avatar ? (
                                    <img className="avatar" src={userData.avatar} />
                                ) : (
                                    <></>
                                )}{' '}
                                {userData.name} (#{userData.id} / $
                                {SystemShared.numberFormat(userData.balance, false)}){' '}
                                <img
                                    className="exit"
                                    src={require('../images/exit.svg').default}
                                    onClick={(e) => {
                                        localStorage.removeItem('userData');
                                        const url = `${location.protocol}//${location.host}/`;

                                        history.pushState({}, null as any, url);
                                    }}
                                /> 
                                */}
                                </div>
                            </>
                        ) : (
                            <>
                                <button
                                    className="rs-btn rs-btn-default dashboardButton"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        // const url = `${location.protocol}//${location.host}/#dashboard`;

                                        // console.log(url);

                                        // history.pushState({}, null as any, url);
                                        EventSystem.setPage('dashboard');
                                    }}
                                >
                                    <img src={require('../images/dashboard.svg').default} />
                                    <span className="dashboardButtonText">
                                        {LangString('DashBoardButton')}
                                    </span>
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {/* <div className="clearfix">
                    <div className="inner">
                        <h3 className="masthead-brand">
                            <img src={LogoWhite} /> RocketMan
                        </h3>
                        <nav>
                            <ul className="nav masthead-nav">
                                <li>
                                    <Dropdown title={<>{LangString(`langName_${lang}` as any)}</>}>
                                        {getAllLangs().map((key) => {
                                            return (
                                                <Dropdown.Item
                                                    key={key}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setLang(key);
                                                    }}
                                                >
                                                    {LangString(`langName_${key}` as any)}
                                                </Dropdown.Item>
                                            );
                                        })}
                                    </Dropdown>
                                </li>
                                {userData ? (
                                    <li className="headerUserData">
                                        {userData.avatar ? (
                                            <img className="avatar" src={userData.avatar} />
                                        ) : (
                                            <></>
                                        )}{' '}
                                        {userData.name} (#{userData.id} / $
                                        {SystemShared.numberFormat(userData.balance, false)}){' '}
                                        <img
                                            className="exit"
                                            src={require('../images/exit.svg').default}
                                            onClick={(e) => {
                                                localStorage.removeItem('userData');
                                                location.reload();
                                            }}
                                        />
                                    </li>
                                ) : (
                                    <></>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div> */}
            </>
        );
    },
);
